import { moveItemInArray } from '@angular/cdk/drag-drop';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { KeyValue, KeyValueI } from '../../models/common';

@Component({
  selector: 'antera-lib-kanban-header-grid',
  templateUrl: './kanban-header-grid.component.html',
  styleUrls: ['./kanban-header-grid.component.scss'],
})
export class KanbanHeaderGridComponent implements OnInit {
  @Input() public title: string = '';
  @Input() public scopeOptions: Array<string> = [];
  @Input() public enableViewOptionsList: Array<KeyValueI> = [];
  @Input() public calendarOptionsList: Array<string> = [];
  @Input() public calendarTypeList: Array<string> = [];
  @Input() public selectedCalendar: string = '';
  @Input() public cogList: Array<string> = [];
  @Input() public viewMyItems = true;
  @Input() public summaryBilling = false;
  @Input() public showSummaryBilling = false;
  @Input() public reSynceNeeded = false;
  @Input() public addBtnList: KeyValue[]=[];
  @Input() public page: string = '';
  @Input() public showClearAllBtn: boolean = false;
  @Input() public calendarOptionsArtworkList: Array<string> = [];
  @Input() public moduleViewOptionsList: Array<string> = [];
  @Input() public defaultProductView: string = '';
  @Input() public mappingFields: any[] =  [];

  @Output() public search: EventEmitter<any> = new EventEmitter();
  @Output() public openAdvancedSearch: EventEmitter<any> = new EventEmitter();
  @Output() public showKanbanView: EventEmitter<any> = new EventEmitter();
  @Output() public onEnableOptionsChange: EventEmitter<any> = new EventEmitter();
  @Output() public onCalendarDateClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onAddBtnClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onToggleViewMyItems: EventEmitter<any> = new EventEmitter();
  @Output() public onToggleSummaryBilling: EventEmitter<any> = new EventEmitter();
  @Output() public onCalendarTypeToggle: EventEmitter<any> = new EventEmitter();
  @Output() public onSettingListClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onClearFilterBtnClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onResetColumns: EventEmitter<any> = new EventEmitter();
  @Output() public onChangeProductionView: EventEmitter<any> = new EventEmitter();
  @Output() public onChangeModuleView: EventEmitter<any> = new EventEmitter();
  @Output() public productSearch: EventEmitter<any> = new EventEmitter();
  @Output() public addNewModule: EventEmitter<any> = new EventEmitter();
  @Output() public onChangeProductView: EventEmitter<any> = new EventEmitter();
  @Input() public defaultModuleView: string = '';
  @Output() public ontToggleResyncQBO: EventEmitter<any> = new EventEmitter();
  
  public selectedView =  ''; 

  @Input() public viewMode: string = '';

  public showKanbanViewFlag: boolean = false;
  public simpleSearchForm = this.fb.group({
    searchTerm: [''],
    searchScope: [''],
  });

  private defaultSelected = ''
  private selection =  ''; 

  constructor(private fb: FormBuilder) {}

  public ngOnInit(): void {
    this.selectedCalendar = this.calendarTypeList?.length  > 0 && !this.selectedCalendar ? this.calendarTypeList[0] : '';
    // this.enableViewOptionsList.sort((a, b) => (a.key > b.key) ? 1 : -1);
  }

  // public ngOnChanges(changes: SimpleChanges){
  //   for(const propName in changes){
  //     if(changes.hasOwnProperty(propName)){
  //       switch(propName){
  //         case 'enableViewOptionsList': {
  //           this.enableViewOptionsList.sort((a,b) => (a.key > b.key) ? 1 : -1);
  //         }

  //       }
  //     }
  //   }
  // }

  /**
   * Basic search that emits event based on search result.
   *
   * @returns {void}
   */
  public simpleSearch(): void {
    const simpleSearchQuery = this.simpleSearchForm.getRawValue();

    this.search.emit(simpleSearchQuery);
  }

  /**
   * Searches and sends value to the parent component.
   *
   * @param {string} searchKey
   * @returns {void}
   */
  public openSearch(pageToOpen: string) {
    this.openAdvancedSearch.emit(pageToOpen);
  }

  /**
   * Emits event when clear all btn on header is clicked.
   *
   * @returns {void}
   */
  public onClearAllClicked(){
    this.onClearFilterBtnClicked.emit();
  }
  /**
   * Displays the kanban view or list view based on current page.
   *
   * @returns {void}
   */
  public displayKanbanPage(): void {
    this.showKanbanViewFlag = !this.showKanbanViewFlag;
    this.showKanbanView.emit(this.showKanbanViewFlag);
  }

  /**
   * On change of the list of enable view options,
   * event is fired.
   *
   * @returns {void}
   */
  public onEnableViewOptions(): void {
    this.onEnableOptionsChange.emit(this.enableViewOptionsList);
  }

  /**
   * On selection of calendar list, event is fired.
   *
   * @param {string} date
   * @returns {void}
   */
  public onCalendarListClick(date: string): void {
    this.onCalendarDateClicked.emit(date);
  }


  /**
   * Emits event when add product is clicked.
   *
   * @returns {void}
   */
  public addBtnClicked(menuSelected: string){
    this.onAddBtnClicked.emit(menuSelected);
  }

  /**
   * Toggles view my items check box on.
   *
   * @param {MatCheckbox} event
   * @returns {void}
   */
  public toggleViewMyItems(event: MatCheckbox | any){
    this.onToggleViewMyItems.emit(event.value);
  }


  /**
   * Toggles summary billing checkbox on.
   *
   * @param {MatCheckbox} event
   * @returns {void}
   */
  public toggleSummaryBilling(event: MatCheckbox | any){
    this.onToggleSummaryBilling.emit(event.value);
  }

  /**
   * Emits event when new calendar search is selected.
   *
   * @returns {void}
   */
  public onCalendarTypeChange(){
    this.onCalendarTypeToggle.emit(this.selectedCalendar);
  }

  public onReorderColumnList(event: any){
    // console.log('value of event', event)
  }

  public onSettingListChange(setting: string){
    this.onSettingListClicked.emit(setting);
  }

  public onColumnListReorder(event: any){
    moveItemInArray(this.enableViewOptionsList, event.previousIndex, event.currentIndex);
    this.enableViewOptionsList.forEach((column: KeyValueI, index: number) => column.optionalValue = index)

    this.onEnableOptionsChange.emit(this.enableViewOptionsList);
  }

  public changeView(ev:any) {
    if(ev.value == 'List View') {
      this.showKanbanViewFlag = false;
    } else if(ev.value == 'Thumbnail View') {
      this.showKanbanViewFlag = true;
    } else if(ev.value == 'Kanban View') {
      this.showKanbanViewFlag = true;
    }
    this.showKanbanView.emit(this.showKanbanViewFlag);
  }

  public changeProductionView(ev:any) {
    this.onChangeProductionView.emit(ev.value);
  }

  public changeProductView(ev:any) {
    this.onChangeProductView.emit(ev.value);
  }

  public changeModuleView(event:any) {
    this.onChangeModuleView.emit(event);
  }

  /* public onEnableDefualtViewOptions() {
    this.onEnableDefualtViewOptions();
  } */

  public advanceProductSearch() {
    this.productSearch.emit();
  }

  public addModule() {
    this.addNewModule.emit();
  }

  public toggleResyncQBO(event: MatCheckbox | any) {
    this.ontToggleResyncQBO.emit(event);
  }
} 
